/* global axios */

import ApiClient from '../ApiClient';

class AstrachatCampaignsAPI extends ApiClient {
  constructor() {
    super('astrachat/campaigns', { accountScoped: true });
  }

  getAudiencePreview(data) {
    return axios.post(
      `${this.baseUrl()}/astrachat/campaign_audience_previews`,
      data
    );
  }

  getReadinessCheck(id) {
    return axios.get(`${this.baseUrl()}/astrachat/campaign_readiness`, {
      params: { campaign_id: id },
    });
  }

  runSimulation(data) {
    return axios.post(`${this.baseUrl()}/astrachat/campaign_simulations`, data);
  }

  cancelContact(id, data) {
    return axios.post(
      `${this.baseUrl()}/astrachat/campaign_contact_cancellations`,
      {
        campaign_id: id,
        ...data,
      }
    );
  }

  requeueTemporaryFailures(id) {
    return axios.post(
      `${this.baseUrl()}/astrachat/campaign_temporary_failure_requeues`,
      {
        campaign_id: id,
      }
    );
  }
}

export default new AstrachatCampaignsAPI();
